
<template>
  <main>
    <login-personalize-preview v-if="config"
                               :initial-config="config" />
  </main>
</template>

<script>
import LoginPersonalizePreview from "@components/modules/login-personalize/preview/LoginPersonalizePreview.vue";

export default {
  components: {
    LoginPersonalizePreview,
  },

  data() {
    return {
      config: undefined,
    };
  },

  computed: {
    user() {
      return this.$store.state.users.user;
    },
  },

  async created() {
    this.loadStyle();
  },

  methods: {
    async loadStyle() {
      const styleId = this.$route.params.id;

      const accountConfig = await this.$api.core.account.captiveStyle.get({
        styleId,
      });

      this.config = {
        ...accountConfig,
        registerStyle: JSON.parse(accountConfig.registerStyle),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
